import ArrowIcon from "/static/images/landing/icons/arrow.svg"
import classNames from "classnames"
import tracking from "../../trackings"

import "./PinnedButton.scss"

const PinnedButton = ({ isVisible }) => {
  const onButtonClick = () => {
    tracking.floatButtonClick()
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  return (
    <div
      className={classNames("landing-pinned-button", {
        "landing-pinned-button--visible": isVisible,
      })}
    >
      <button className="landing-pinned-button__button" onClick={onButtonClick}>
        Consultar CPF
        <ArrowIcon className="landing-pinned-button__icon" />
      </button>
    </div>
  )
}

export default PinnedButton
